import { evaluate } from 'cel-js';
import i18next from 'i18next';

import { Variables } from '../types';

const templating = i18next.createInstance();
templating.init({
    interpolation: {
        // We want to replace all variables, even if they are not found in the context.
        // Missing variables will be replaced with an empty string.
        skipOnVariables: false
    },
    // nsSeparator: false will remove that detection of namespaces in keys passed in t function, and will allow strings with colons, like URLs
    nsSeparator: false
});

// Add a formatter for the toISOString function.
templating.services.formatter?.add('toISOString', (value) =>
    new Date(value).toISOString()
);

templating.services.formatter?.add(
    'celExpression',
    (value, _, options): string =>
        String(evaluate(options.interpolationkey, options))
);

// We are using translate function to do a safe substitution for context values.
// A fresh instance is set with a unique context and language to prevent colusion
const t = templating.getFixedT('en', 'context');

export function templateInterpolation(
    template: unknown,
    variables: Variables = {}
) {
    if (!template) return null;

    return typeof template !== 'string'
        ? i18next.t(String(template))
        : i18next.t(t(template, variables));
}
